import {ALL_REGIONS} from "../../../designSystem/components/AddressInput/AddressInput";

export const formatAddress = (region: string, address: string) => {
  const matchedRegion = ALL_REGIONS.find(r => address.includes(r));
  if (!matchedRegion) {
    return `${region}, ${address}`;
  }

  let rest = address.replace(matchedRegion, '').trim();
  rest = rest.replace(/^屏東縣/, '').trim();
  return [matchedRegion, rest];
}
